import {
    CREATE_ACCESSORIES_DC_FAILURE_DK,
    CREATE_ACCESSORIES_DC_REQUEST_DK,
    CREATE_ACCESSORIES_DC_SUCCESS_DK,
    CREATE_USER_FORM_ACCESSORIES_DC_DK,
    FETCH_SINGLE_ACCESSORIES_DC_FAILURE_DK,
    FETCH_SINGLE_ACCESSORIES_DC_REQUEST_DK,
    FETCH_SINGLE_ACCESSORIES_DC_SUCCESS_DK,
    FETCH_ACCESSORIES_DC_FAILURE_DK,
    FETCH_ACCESSORIES_DC_REQUEST_DK,
    FETCH_ACCESSORIES_DC_SUCCESS_DK,
    NAVIGATE_ACCESSORIES_DC_DETAILS_DK,
    NAVIGATE_ACCESSORIES_DC_DK,
    ACCESSORIES_DC_USERFORM_RESET_DK,
    UPDATE_ACCESSORIES_DC_FAILURE_DK,
    UPDATE_ACCESSORIES_DC_REQUEST_DK,
    UPDATE_ACCESSORIES_DC_SUCCESS_DK,
    DELETE_ACCESSORIES_DC_REQUEST_DK,
    DELETE_ACCESSORIES_DC_SUCCESS_DK,
    DELETE_ACCESSORIES_DC_FAILURE_DK,
    ACCESSORIES_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB_DK,
    ACCESSORIES_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE_DK,
    FETCH_ACCESSORIES_DC_STYLE_REQUEST_DK,
    FETCH_ACCESSORIES_DC_STYLE_SUCCESS_DK,
    FETCH_ACCESSORIES_DC_STYLE_FAILURE_DK,
    FETCH_ACCESSORIES_DC_INVOICE_REQUEST,
    FETCH_ACCESSORIES_DC_INVOICE_SUCCESS,
    FETCH_ACCESSORIES_DC_INVOICE_FAILURE,
    RESET_ACCESSORIES_DC_INVOICE,
   

} from './accessoriesDC.actionsType';

export const ACCESSORIES_DC_DK = 'accessoriesDCDK';

let initialState = {
    loading: false,
    accessoriesDC: [],
    accessoriesDCInvoice:[],
    accessoriesDCStyleList: [],
    userform: {
        fldFKDeliveryAt: '',
        fldFKSupplierID: '',
        fldIsInHouseDelivery: false,
        fldIsInHouseProduction: false,
        fldItemsTotalValue: 0,
        fldGrandGrossValue: 0,
        fldOtherPlusValue: 0,
        fldOtherMinusValue: 0,
        fldRoundoff: 0
    },
    selectedTeam: {},
    detailsId: '',
    activeKey: 1,
    isAccessoriesDC: false,
    accessoriesDCSelectedValue: {},
    errorMessage: '',
    iperrorMessage: ''
};

export let accessoriesDCDKReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_ACCESSORIES_DC_REQUEST_DK:
        case FETCH_ACCESSORIES_DC_INVOICE_REQUEST:
        case FETCH_ACCESSORIES_DC_STYLE_REQUEST_DK:
        case CREATE_ACCESSORIES_DC_REQUEST_DK:
        case FETCH_SINGLE_ACCESSORIES_DC_REQUEST_DK:
        case UPDATE_ACCESSORIES_DC_REQUEST_DK:
        case DELETE_ACCESSORIES_DC_REQUEST_DK:
            return {
                ...state,
                loading: true
            };
        case FETCH_ACCESSORIES_DC_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                accessoriesDC: updatePayload
            };
        
        case FETCH_ACCESSORIES_DC_INVOICE_SUCCESS:
            return {
                ...state,
                loading: false,
                accessoriesDCInvoice: updatePayload
            };

            case FETCH_ACCESSORIES_DC_STYLE_SUCCESS_DK:
                return {
                    ...state,
                    loading: false,
                    accessoriesDCStyleList: updatePayload
                };
               
        case CREATE_ACCESSORIES_DC_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0
                },
                detailsId: updatePayload
            };
        case FETCH_SINGLE_ACCESSORIES_DC_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedTeam: updatePayload,
                userform: updatePayload
            };
        case UPDATE_ACCESSORIES_DC_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0
                },
                detailsId: ''
            };
        case DELETE_ACCESSORIES_DC_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0
                },
                detailsId: ''
            };
        case FETCH_ACCESSORIES_DC_FAILURE_DK:
        case FETCH_ACCESSORIES_DC_INVOICE_FAILURE:
        case FETCH_ACCESSORIES_DC_STYLE_FAILURE_DK:
        case FETCH_SINGLE_ACCESSORIES_DC_FAILURE_DK:
        case CREATE_ACCESSORIES_DC_FAILURE_DK:
        case UPDATE_ACCESSORIES_DC_FAILURE_DK:
        case DELETE_ACCESSORIES_DC_FAILURE_DK:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_ACCESSORIES_DC_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case ACCESSORIES_DC_USERFORM_RESET_DK:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0
                },
                detailsId: '',
                activeKey: 1
            };
        case NAVIGATE_ACCESSORIES_DC_DETAILS_DK:
            return {
                ...state,
                isAccessoriesDC: true,
                accessoriesDCSelectedValue: updatePayload
            };
        case NAVIGATE_ACCESSORIES_DC_DK:
            return {
                ...state,
                isAccessoriesDC: false
            };
            case RESET_ACCESSORIES_DC_INVOICE:
                return {
                    ...state,
                    accessoriesDCInvoice: []
                };
        case ACCESSORIES_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB_DK:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0
                },
                activeKey: 2
            };
        case ACCESSORIES_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE_DK:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0
                },
                activeKey: 1
            };
        default:
            return state;
    }
};
